import { Container, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import { useSettingsContext } from 'src/components/settings';
import { getTelecarePackages } from 'src/services/telehealth-packages.service';
import TherapyPackageCard from 'src/components/telehealth-packages-card/telepackages-card';
import AddTherapyPackageCard from 'src/components/telehealth-packages-card/telepackages-card-add';

export default function ClinicTherapyPackagesView() {
  const settings = useSettingsContext();
  const { user } = useAuthContext();
  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    getTelecarePackages(user.clinic_id)
      .then((res) => {
        const packages = res || [];

        const tempCardData = packages.map((pkg) => ({
          id: pkg.id,
          package_name: pkg.package_name,
          description: pkg.description,
          price: pkg.price,
          duration: pkg.duration,
          is_active: pkg.is_active,
          clinic_id: user.clinic_id,
          image_url: pkg.image_url || [],
        }));

        setCardData(tempCardData);
      })
      .catch((error) => {
        console.log('Error fetching therapy packages:', error);
      });
  }, [user.clinic_id]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'} sx={{ marginY: '24px' }}>
      <Grid container spacing="18px">
        <Grid item lg={4} xl={3} xs={6}>
          <AddTherapyPackageCard />
        </Grid>

        {cardData.map((cardDetails) => (
          <Grid item xs={6} key={cardDetails.id} lg={4} xl={3}>
            <TherapyPackageCard cardDetails={cardDetails} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
